import { Weekday } from './types/weekday';

export const isMagnoliaEditingMode = (): boolean => window.ui?.cmsState?.mode === 'editing';

export const getDocumentHeight = () => {
  const { body } = document;

  const html = document.documentElement;

  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
};

export const getDetailedError = (page) => {
  page?.on('console', async (msg) => {
    const args = await msg.args();
    args.forEach(async (arg) => {
      const val = await arg.jsonValue();
      // value is serializable
      // eslint-disable-next-line no-console
      if (JSON.stringify(val) !== JSON.stringify({})) console.log(val);
      // value is unserializable (or an empty oject)
      else {
        /* eslint-disable no-underscore-dangle */
        const { type, subtype, description } = arg._remoteObject;
        // eslint-disable-next-line no-console
        console.log(`type: ${type}, subtype: ${subtype}, description:\n ${description}`);
      }
    });
  });
};

export const getLocaleTime = (
  timestamp: string,
  locale: string = document.documentElement.lang || 'de-DE',
  timeZone = 'UTC'
) => {
  const localeTimeString = new Date(timestamp).toLocaleTimeString(locale, {
    timeStyle: 'short',
    timeZone,
  });
  const suffix = locale.startsWith('de') ? 'Uhr' : '';
  return `${localeTimeString} ${suffix}`;
};

export const getFromDay = (weekday: Weekday) => `from${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}`;

export const getToDay = (weekday: Weekday) => `to${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}`;
